import type { OfferDto, SpotDto, TreatStatusDto } from "@boomap/contracts";

/**
 * Couleurs des états de bonbons. Une seule source de vérité : les SVG des
 * pastilles, les couches MapLibre et la légende y puisent.
 */
/*
 * Les gris de l'état « épuisé » sont volontairement soutenus : une teinte
 * claire disparaissait sur le fond de carte de jour, où son liseré blanc ne
 * détachait plus rien. Assombri, il se lit sur les deux thèmes — le liseré
 * portant le contraste de nuit, le corps de jour.
 */
export const TREAT_COLORS: Record<TreatStatusDto, string> = {
  available: "#ff9d3f",
  exhausted: "#6f7a8c",
  none: "#b48cff",
};

/**
 * Teinte soutenue des papillotes du bonbon. Sans elle, elles se fondaient dans
 * le corps et la silhouette se lisait comme une simple tache ronde.
 */
export const TREAT_DEEP_COLORS: Record<TreatStatusDto, string> = {
  available: "#e87a1e",
  exhausted: "#525c6b",
  none: "#9a6df0",
};

/**
 * États proposés à la saisie. `none` en est absent : la décoration n'étant plus
 * exposée dans l'interface, une pastille « pas de bonbons » n'annoncerait rien
 * et le domaine la refuserait.
 */
export const TREAT_ORDER: readonly TreatStatusDto[] = ["available", "exhausted"];

/**
 * États montrés dans la légende. Identiques aux états saisissables : expliquer
 * un symbole qu'on ne peut pas produire n'apprendrait rien.
 */
export const LEGEND_TREATS: readonly TreatStatusDto[] = TREAT_ORDER;

export const offerOf = (spot: SpotDto): OfferDto => ({
  treats: spot.treats,
  decorated: spot.decorated,
});

/**
 * Toutes les silhouettes à rastériser. Y compris `none`, qui n'est plus
 * saisissable mais peut subsister en base : une pastille sans image ne se
 * dessinerait pas du tout.
 */
export const TREAT_VARIANTS: readonly TreatStatusDto[] = ["available", "exhausted", "none"];

/**
 * L'image ne dépend que de l'état des bonbons. La décoration, retirée de
 * l'interface, ne se traduit plus par un anneau : un symbole que la légende
 * n'explique pas ne renseigne personne.
 */
export const treatIconId = (treats: TreatStatusDto): string => `spot-${treats}`;
